export const VALIDATION_PATTERNS = {
  EMAIL: /^\s*(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))\s*$/,
  NAME: /^(?!^\d+$)[a-zA-Z0-9!@#$^*()?><(){}:;.,_+=\\/~`-]+(?: [a-zA-Z0-9!@#$^*()?><(){}:;.,_+=\\/~`-]+)*$/,
  PASSWORD: /^[a-zA-Z0-9!@#$%^&*]+$/i,
  PHONE: /^\+?[0-9]{2}[0-9]{10,20}$/,
  PHONE_PATTERN: /^\+?[0-9]{7,}$/, //7 minimum and 15 maximum
  USERNAME: /^[a-z0-9A-Z]+$/i,
  POSITIVE_INTEGER: /^[0-9," "]+$/i,
  NAME2:/^\b([A-ZÀ-ÿ][-,a-z. ']+[ ]*)+$/i,
   SPACERISTRICT:/^[^\s][\s\S]*$/,
  SPACERISTRICTDISALLOWSTARTENDSPACE:/^\S(?:.*\S)?(?:\n\S.*\S)*$/,
  NOTALLOW_SPECIAL_CHAR:/^[^%']+$/,
  ONLYNUMERIC_NOTALLOW:/^(?!^\d+$)[\s\S]*$/,
  ONLYNUMERIC:/^[0-9]+(\.[0-9]{1,2})?$/,///^[0-9]+$/,
  NOZERO:/^(?!0$)\d+$/,
  NUMERICWITHTWODECIMAL:/^[0-9]+(\.[0-9]{1,2})?$/,
  iChars: /^[^`!@#$%^&*()+=\-[\]\\';,./{}|":<>?]+$/,
  SPACESTRICTFORINITIALVALIDATION:/^\S[^\n]*([\n][\s\S]*)?$/,

  NOTALLOW_SPECIAL_CHAR_NAME: /^[a-zA-Z0-9\s']+$/

}




